import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  private readonly ID_TOKEN_KEY = 'idToken';
  private readonly ID_TOKEN_EXPIRATION_KEY = 'idToken_expiration';
  private readonly REFRESH_TOKEN_KEY = 'refresh_token';

  setIdToken(token: string): void {
    localStorage.setItem(this.ID_TOKEN_KEY, token);
  }

  getIdToken(): string | null {
    return localStorage.getItem(this.ID_TOKEN_KEY);
  }

  setIdTokenExpiration(expiration: number): void {
    localStorage.setItem(this.ID_TOKEN_EXPIRATION_KEY, expiration.toString());
  }

  getIdTokenExpiration(): number {
    const exp = localStorage.getItem(this.ID_TOKEN_EXPIRATION_KEY);
    return exp ? parseInt(exp, 10) : 0;
  }

  /** Vérifie le claim `exp` du JWT, avec une marge pour absorber le décalage d'horloge. */
  isIdTokenExpired(token: string | null = this.getIdToken(), skewSeconds = 30): boolean {
    if (!token) {
      return true;
    }
    try {
      const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const { exp } = JSON.parse(atob(payload));
      return typeof exp !== 'number' || exp - skewSeconds <= Date.now() / 1000;
    } catch {
      return true;
    }
  }

  setRefreshToken(token: string): void {
    localStorage.setItem(this.REFRESH_TOKEN_KEY, token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  clear(): void {
    localStorage.removeItem(this.ID_TOKEN_KEY);
    localStorage.removeItem(this.ID_TOKEN_EXPIRATION_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }
}